import { setExpandedAccordionOnDetailsPage } from 'component/page/detail/store/details';
import { createSelector } from '@reduxjs/toolkit';
import { selectExpandedModularAccordionFromDetailState } from 'component/page/detail/store/detail.selectors';
import { ContentWrapperProps } from 'component/page/detail/DetailPageModularize/ContentWrapper/ContentWrapper.types';
import { ContentHandlerMetaInfo } from 'component/page/detail/DetailPageModularize/contentRegistry.type';

export interface DispatchProps {
    setExpandedAccordionOnDetailsPage: (href: string, status: boolean) => void;
}

export interface StateProps {
    expandedModularAccordion: Record<string, boolean>;
}

export const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    setExpandedAccordionOnDetailsPage: (href: string, status: boolean) => {
        dispatch(setExpandedAccordionOnDetailsPage({ selector: `#${href}`, status }));
    },
});

export const mapStateToProps = createSelector(
    selectExpandedModularAccordionFromDetailState,
    (expandedModularAccordion): StateProps => ({
        expandedModularAccordion,
    }),
);

export type AccordionContainerProps = ContentWrapperProps & DispatchProps & StateProps & { customMeta: ContentHandlerMetaInfo };
